import { Dispatch, Action } from 'redux'
import { LabelCardMapDispatchReturnType } from './types/LabelCardMapDispatchReturnType'

export const LabelCardMapDispatch = (
  _dispatch: Dispatch<Action>
): LabelCardMapDispatchReturnType => {
  return {}
}
